import axios from 'axios';

// export const HTTPMTN = axios.create({
//   baseURL: `https://trendtody.com/MTNAPIs_SudaVas/APIs/`,
// })

const baseURL = process.env.VUE_APP_API_URL_MTN;

// Validate environment variables
if (!baseURL) {
  console.warn('VUE_APP_API_URL_MTN is not defined');
}

export const HTTPMTN = axios.create({
  baseURL,
  timeout: 20000, // 20 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for dynamic auth token
HTTPMTN.interceptors.request.use((config) => {
  const token = process.env.VUE_APP_MTN_AUTH_TOKEN;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor for error handling
HTTPMTN.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common errors here
    if (error.response) {
      // Server responded with error status
      if (process.env.NODE_ENV !== 'production') {
        console.error('API Error:', error.response.status, error.response.data);
      }
      if (error.response.status === 401) {
        console.error('Authentication failed. Please check your credentials.');
      }
    } else if (error.request) {
      // Request made but no response received
      console.error('Network Error:', error.request);
    } else {
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);
